export default __webpack_public_path__ + "static/media/00.08dc5dc7.jpg";